import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
let cache = null;
let inflight = null;
const subs = new Set();

const notify = () => subs.forEach((cb) => cb(new Set(cache)));

async function load() {
  if (cache) return cache;
  if (!inflight) {
    inflight = axios.get(`${API}/posts/saved/ids`).then((r) => { cache = new Set(r.data || []); return cache; }).catch(() => (cache = new Set())).finally(() => { inflight = null; });
  }
  return inflight;
}

/** Shared saved-posts set: one request per session, optimistic toggling across all PostMenu instances. */
export function useSavedPosts() {
  const [ids, setIds] = useState(cache ? new Set(cache) : new Set());
  useEffect(() => {
    subs.add(setIds);
    load().then(() => setIds(new Set(cache)));
    return () => subs.delete(setIds);
  }, []);
  const toggle = async (postId) => {
    await load();
    const was = cache.has(postId);
    if (was) cache.delete(postId); else cache.add(postId);
    notify();
    try {
      if (was) await axios.delete(`${API}/posts/${postId}/save`);
      else await axios.post(`${API}/posts/${postId}/save`);
    } catch (e) {
      if (was) cache.add(postId); else cache.delete(postId);
      notify();
      throw e;
    }
    return !was;
  };
  return { savedIds: ids, isSaved: (id) => ids.has(id), toggle };
}

export function resetSavedPostsCache() { cache = null; }
